/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   :modal-append-to-body="false"
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form label-width="150px" class="condition-form-item" :model="rowForm" ref="rowForm">
                <el-form-item label="基站编号：">
                    {{insertBs.bsId + " (" + insertBs.bsSid + ")"}}
                </el-form-item>
                <el-form-item label="安装序号：" v-if="insertBs.bsSerial">
                    {{insertBs.bsSerial}}
                </el-form-item>
                <el-form-item label="插入方式：" prop="forward">
                    <el-radio-group v-model="rowForm.forward">
                        <el-radio class="radio" :label="true">插到基站前面</el-radio>
                        <el-radio class="radio" :label="false">插到基站后面</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="插入的新基站：" prop="bsSid">
                    <el-select v-model="rowForm.bsSid" placeholder="请选择基站">
                        <el-option v-for="(item, index) in unRangeBs" :key="item.sid" :label="item.bsId + '('+item.sid+')'" :value="item.sid" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="row-items-1 btn-form-item-c" style="padding-top: 20px;">
                    <el-button type="primary" @click.native="submit">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>
import ApiOam from '@/request/api-oam'
export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbBSRangeInsertDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {
        unRangeBs: {
            type: Array,
            default: function (){
                return []
            }
        },
        groupId:{
            type: Number,
            default: function (){
                return 0;
            }
        },
        insertBs: {
            type: Object,
            default: function (){
                return {};
            }
        }
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            // 查询表单
            rowForm:{
                bsSid: '',
                forward: true,
            },
        }
    },
    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {
        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            if(this.rowForm.bsSid == ''){
                this.$message({
                    message: '请选择基站',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            this.operationLock = true;
            this.$request.postJsonRequest(ApiOam.Insert_Uwb_Range_Bs_Uri, {
                groupId: this.insertBs.groupId,
                bsSid: this.insertBs.bsSid,
                addBsSid: this.rowForm.bsSid,
                forward: this.rowForm.forward
            }).then(result => {
                if(result.code == 0){
                    this.$message({
                        message: '插入成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.handleDialogClose();
                    this.rowForm.bsSid = '';
                    this.$emit("research");
                }else{
                    this.$message({
                        message: result.msg,
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
                this.operationLock = false;
            }).catch(error => {
            	this.operationLock = false;
            	console.error('插入测距基站异常', ApiOam.Insert_Uwb_Range_Bs_Uri, error);
            });
        },
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 800px;
	}
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}
    /deep/ .el-select .el-input__inner{
        width: 555px;
    }

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSRangeInsertDialog.vue